/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { EnvService } from "namirasoft-core";
import { JobCategoryMetaTable } from "./JobCategoryMetaTable";
import { JobFieldMetaTable } from "./JobFieldMetaTable";
import { JobMetaTable } from "./JobMetaTable";
import { JobTagMetaTable } from "./JobTagMetaTable";
import { NSBaseMetaDatabase } from "namirasoft-site";
import { NamirasoftJobArrangerServer } from "../NamirasoftJobArrangerServer";
import { ReasonCategoryMetaTable } from "./ReasonCategoryMetaTable";
import { ReasonFieldMetaTable } from "./ReasonFieldMetaTable";
import { ReasonMetaTable } from "./ReasonMetaTable";
import { ReasonTagMetaTable } from "./ReasonTagMetaTable";
import { TokenManager } from "namirasoft-account";

export class NamirasoftJobArrangerMetaDatabase extends NSBaseMetaDatabase<NamirasoftJobArrangerServer>
{
    private manager?: TokenManager;
    private onError?: (error: Error) => void;
    public override tables: {
        job: JobMetaTable,
        job_category: JobCategoryMetaTable,
        job_field: JobFieldMetaTable,
        job_tag: JobTagMetaTable,
        reason_category: ReasonCategoryMetaTable,
        reason_field: ReasonFieldMetaTable,
        reason_tag: ReasonTagMetaTable,
        reason: ReasonMetaTable,
    };
    constructor(manager?: TokenManager, onError?: (error: Error) => void)
    {
        super({ id: "prd-23e6a126ab4e4627", name: "Namirasoft Job Arranger", headline: "Job Search Management", description: "A platform designed to assist job seekers in organizing their job search efforts. It simplifies the job search process by offering various features that streamline the path to employment.", logo: "https://static.namirasoft.com/image/namirasoft/job-arranger/logo/base.png", link: "https://job-arranger.namirasoft.com" });
        this.manager = manager;
        this.onError = onError;
        this.tables = {
            job: new JobMetaTable(this),
            job_category: new JobCategoryMetaTable(this),
            job_field: new JobFieldMetaTable(this),
            job_tag: new JobTagMetaTable(this),
            reason_category: new ReasonCategoryMetaTable(this),
            reason_field: new ReasonFieldMetaTable(this),
            reason_tag: new ReasonTagMetaTable(this),
            reason: new ReasonMetaTable(this),
        };
    }
    override getServer(): NamirasoftJobArrangerServer
    {
        if (!this.manager || !this.onError)
            throw new Error("Arguments of NamirasoftJobArrangerMetaDatabase (manager, onError) are required for server operations.")
        let NAME = NSBaseMetaDatabase.getServerBaseURL(this.product.name);
        let BASE_URL = new EnvService(NAME, true).getString();
        return new NamirasoftJobArrangerServer(BASE_URL, this.manager, this.onError);
    }
};